module.exports = __webpack_public_path__ + "img/qr_captain.65bd628c.jpg";